// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"452":"e6c6a9caf0f28945","745":"e6c6a9caf0f28945","888":"6ab07d6d8f54d16c"}[chunkId] + ".css";
};